"use strict";

exports.__esModule = true;
exports.UpdateAlertWatcherRuleScreen = UpdateAlertWatcherRuleScreen;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _App = require("../../App");
var _API = require("../../API");
var _AlertWatcherRuleForm = require("../AlertWatcherRuleForm");
var _System = require("../../../System");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function UpdateAlertWatcherRuleScreen(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_API.CollectionGetter, {
    collection: props.collection,
    id: props.match.params.id
  }, function (_ref) {
    var fetching = _ref.fetching,
      data = _ref.data;
    if (fetching || !data) {
      return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
        title: translate("UpdateAlertWatcherRuleScreen.title.loading", "Loading Alert Watcher Rule...")
      }, /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null));
    }
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("UpdateAlertWatcherRuleScreen.title", "Edit {name}", {
        name: data.name
      })
    }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("UpdateAlertWatcherRuleScreen.navbar.title", "Edit {name}", {
        name: data.name
      })
    }), /*#__PURE__*/_react["default"].createElement(_AlertWatcherRuleForm.AlertWatcherRuleForm, {
      initialValues: {
        name: data.name,
        enabled: data.enabled,
        tags: data.tags,
        from: data.from,
        to: data.to,
        daysOfTheWeek: data.daysOfTheWeek,
        devices: data.devices.filter(function (item) {
          return item.type === "UUID";
        }).map(function (item) {
          return item.value;
        }),
        deviceTags: data.devices.filter(function (item) {
          return item.type === "TAG";
        }).map(function (item) {
          return item.value;
        }),
        users: data.watchers.filter(function (item) {
          return item.type === "USER";
        }).map(function (item) {
          return item.value;
        }),
        emails: data.watchers.filter(function (item) {
          return item.type === "EMAIL";
        }).map(function (item) {
          return item.value;
        })
      },
      onSubmit: function onSubmit(_ref2) {
        var name = _ref2.name,
          enabled = _ref2.enabled,
          tags = _ref2.tags,
          from = _ref2.from,
          to = _ref2.to,
          daysOfTheWeek = _ref2.daysOfTheWeek,
          devices = _ref2.devices,
          deviceTags = _ref2.deviceTags,
          users = _ref2.users,
          emails = _ref2.emails;
        return props.collection.updateWithoutID({
          id: data.id,
          name: name,
          enabled: enabled,
          tags: tags,
          from: from,
          to: to,
          daysOfTheWeek: daysOfTheWeek,
          devices: devices.map(function (value) {
            return {
              type: "UUID",
              value: value
            };
          }).concat(deviceTags.map(function (value) {
            return {
              type: "TAG",
              value: value
            };
          })),
          watchers: users.map(function (value) {
            return {
              type: "USER",
              value: value
            };
          }).concat(emails.map(function (value) {
            return {
              type: "EMAIL",
              value: value
            };
          }))
        }).then(function () {
          props.onSave();
          props.history.push((0, _System.getScreenLocation)("AlertWatcherRuleList"));
        });
      },
      onDelete: function onDelete() {
        return props.collection["delete"](data.id).then(function () {
          props.onDelete();
          props.history.push((0, _System.getScreenLocation)("AlertWatcherRuleList"));
        });
      }
    }));
  });
}